export default __webpack_public_path__ + "static/media/basicinfo-view-details.da544780.svg";